<template>
	<div class="gb-alert-schedule"
		v-bind:style="styleAlertSchedule"
	>
	</div>
</template>
<script>
import { UNIT_WIDTH } from '../data/Const';
export default {
	name: 'GBCAlertSchedule',
	props: [
		"height",
		"schedule",
	],
	computed: {
		styleAlertSchedule: function() {
			let base_date = new Date(this.$store.getters.calendarBaseDate);
			let tick_width = UNIT_WIDTH.TICK / this.$store.getters.unitTicks;
			
			let offset_begin_ticks = this.schedule.begin.offsetTicks(base_date);
			let ticks = this.schedule.ticks;

			let left = offset_begin_ticks * tick_width;

			return {
				height: this.height + 'px',
				width: (ticks * tick_width) + 'px',
				left: left + 'px',
			};
		},
	},
};
</script>
<style>
	.gb-alert-schedule {
		display: inline-block;
		position: absolute;
		opacity: .6;
		border-radius: 0px;
		border-style: dashed;
		border-width: 3px;
		border-color: crimson;
		background-color: orange;
	}
</style>
